'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleSheet = {
  root: {
    backgroundColor: _colors2.default.white,
    borderBottom: '1px solid ' + _colors2.default.grey,
    position: 'relative',
    padding: '8px 56px',
    boxSizing: 'border-box',
    height: '48px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textContainer: {
    width: '100%'
  },
  text: {
    color: _colors2.default.secondaryText,
    fontSize: '16px',
    fontWeight: 'bolder',
    margin: 0,
    textAlign: 'center',
    lineHeight: '16px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  secondaryText: {
    color: _colors2.default.theme,
    fontSize: '14px',
    fontWeight: 'inherit',
    marginTop: '8px',
    marginBottom: 0,
    textAlign: 'center',
    lineHeight: '16px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  rightButton: {
    width: '40px',
    height: '40px',
    position: 'absolute',
    right: '8px',
    top: '4px'
  },
  leftButton: {
    width: '40px',
    height: '40px',
    position: 'absolute',
    left: '8px',
    top: '4px'
  }
};

exports.default = styleSheet;
module.exports = exports.default;